class View {
  [x: string]: any;
  static $inject = [
    'Users',
    'Toast',
    'RolesService',
    'ModalService',
    'PermPermissionStore',
    'AuthService',
    '$window',
    '$translate',
    'NotificationService',
    'AmplitudeService',
    '$location',
    'Router',
  ];
  constructor(
    Users,
    Toast,
    RolesService,
    ModalService,
    PermPermissionStore,
    AuthService,
    $window,
    $translate,
    NotificationService,
    AmplitudeService,
    $location,
    Router
  ) {
    this.Users = Users;
    this.toast = Toast;
    this.rolesService = RolesService;
    this.ModalService = ModalService;
    this.PermPermissionStore = PermPermissionStore;
    this.Users = Users;
    this.AuthService = AuthService;
    this.$window = $window;
    this.$translate = $translate;
    this.notificationService = NotificationService;
    this.amplitudeService = AmplitudeService;
    this.$location = $location;
    this.router = Router;
  }

  $onInit() {
    if (!this.AuthService.isOwner() && this.user.role.toUpperCase() === 'OWNER') {
      this.goToUserDetails();
    }

    this.roles = this.rolesService.query();
    this.currentUserRoleId = this.user.roleId;
    this.amplitudeService.logEvent('Panel:Users:Edit: Init');
  }

  // destroys closable notification of 'failed StripePayment' which also redirects here
  $onDestroy() {
    this.notificationService.dismiss();
  }

  saveSettings() {
    this.amplitudeService.logEvent('Panel:Users:Edit: Save');
    const { name: firstName, surname, username: email, msisdns, roleId } = this.user;
    const updateUserRequest = {
      firstName,
      roleId,
      email,
      surname,
      msisdns,
    };
    this.Users.edit({ id: this.user.id }, updateUserRequest, () => {
      if (this.isChangedCurrentRole()) {
        this.$window.location.href = '/';
      } else {
        this.$location.url(`/users/${this.state}/${this.userIndex}/details`);
        this.toast.success('CHANGES_SAVED');
      }
    });
  }

  updateEnabled() {
    this.isActive() ? this.setDisabled() : this.setEnabled();
  }

  setEnabled() {
    this.userStats.activeCount + this.userStats.pendingCount >= this.userStats.limit
      ? this.showModalLimit()
      : this.Users.enable({ id: this.user.id }, {}, () => {
          this.toast.success('CHANGES_SAVED');
          this.reloadState('active', true);
        });
  }

  setDisabled() {
    this.ModalService.showModalConfirm({ title: 'USERS.DEACTIVATE.TITLE', body: 'USERS.DEACTIVATE.BODY' }).then(() =>
      this.Users.disable({ id: this.user.id }, {}, () => {
        this.toast.success('CHANGES_SAVED');
        this.reloadState('inactive', false);
      })
    );
  }

  reloadState(state, enabled) {
    if (this.state === 'all') {
      // dirty hack to force the reload
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigateByUrl(`/users/all/${this.userIndex}/edit`);
      });
    } else {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigateByUrl(`/users/${state}/${this.userIndex}/edit`);
      });
    }
  }

  showModalLimit() {
    this.ModalService.showModal(
      this.PermPermissionStore.hasPermissionDefinition('CHANGE_BILLING_PERMISSION')
        ? { title: 'LIMITS.OWNER.TITLE', body: 'LIMITS.OWNER.CONTENT' }
        : { title: 'LIMITS.ADMIN.TITLE' }
    );
  }

  isActive() {
    return this.user.state === 'ACTIVE';
  }

  isChangedCurrentRole() {
    return (
      this.AuthService.currentUser().username === this.user.username && this.user.roleId !== this.currentUserRoleId
    );
  }

  close() {
    this.amplitudeService.logEvent('Panel:Users:Edit: Close');
    this.goToUserDetails();
  }

  onUpdateMsisdns(msisdns) {
    this.user.msisdns = msisdns;
  }

  goToUserDetails() {
    this.router.navigateByUrl(`/users/${this.state}/${this.userIndex}/details`);
  }
}

export default {
  controller: View,
  template: require('./users.edit.html'),
  bindings: { user: '<', userStats: '<', userIndex: '<', state: '<' },
};
